// append tiny swiper styles to the document head
import { tns } from 'tiny-slider'
import { map, debounce } from 'lodash'


const initTns = (element) => tns({
    container: element,
    axis: 'vertical',
    items: 1,
    center: true,
    controls: false,
    nav: false,
    speed: 300,
    autoplayTimeout: Math.random() * (8000 - 2000) + 2000,
    autoplay: true,
    autoplayButtonOutput: false,
    gutter: 10,
    lazyload: true,
    lazyloadSelector: 'lazyloading'
});

map(document.querySelectorAll('.logo-swiper-wrapper'), (element) => initTns(element));

let hideMobileSliders = [];
const resizeEventListener =() => {
    if(window.innerWidth >= 768) {
        if(!hideMobileSliders.length) {
            hideMobileSliders = map(document.querySelectorAll('.logo-swiper-wrapper-hide-mobile'), (element) => initTns(element));
        }
    } else {
        hideMobileSliders.forEach( slider => slider.destroy());
        hideMobileSliders = [];
    }
}

window.addEventListener('resize',  debounce(resizeEventListener, 100, {leading: true}) );
resizeEventListener();